import React from 'react';
import { InfoCardVariants, TableColumn } from '@backstage/core-components';
import { EntityTable, useEntity } from '@backstage/plugin-catalog-react';
import {
  Entity,
  RELATION_HAS_PART,
  RELATION_OWNER_OF,
  RELATION_PARENT_OF,
  SystemEntity,
} from '@backstage/catalog-model';
import { RelatedEntitiesCard } from '../RelatedEntitiesCard/RelatedEntitiesCard';

export interface HasSystemCardProps {
  variant?: InfoCardVariants;
}

export const HasSystemsCard = (props: HasSystemCardProps) => {
  function relationType(entity: Entity): string {
    if (entity.kind === 'Group') {
      return RELATION_OWNER_OF;
    } else if (entity.kind === 'Domain') {
      return RELATION_HAS_PART;
    } else if (entity.kind === 'Service') {
      return RELATION_HAS_PART;
    } else if (entity.kind === 'Provider') {
      return 'providesDataTo';
    }
    return RELATION_PARENT_OF;
  }

  const { variant = 'gridItem' } = props;
  const { entity } = useEntity();

  const resourceEntityColumns: TableColumn<SystemEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'system' }),
    EntityTable.columns.createSpecLifecycleColumn(),
    EntityTable.columns.createMetadataDescriptionColumn(),
  ];

  const asResourceEntities = (entities: Entity[]): SystemEntity[] =>
    entities as SystemEntity[];
  const title = entity.kind === 'Systems' ? 'Sub-Systems' : 'Systems';

  return (
    <>
      {entity.relations?.find(it => it.type === relationType(entity)) && (
        <RelatedEntitiesCard
          variant={variant}
          title={title}
          entityKind="System"
          relationType={relationType(entity)}
          columns={resourceEntityColumns}
          asRenderableEntities={asResourceEntities}
        />
      )}
    </>
  );
};
